<b-modal v-model="modal_requirement_143" :size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px; white-space: pre-wrap;">
        <div class="w-100">
          <div class="box-margin-right work-support-message">
            {{ workSupportMessage }}
          </div>
        </div>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <b-button v-if="showButtonCancel" size="sm" :disabled="isLoading" variant="outline-primary" @click="closeWizard"
        class="mx-2">
        {{ $t('message.common_button_cancel') }}
      </b-button>
      <b-button size="sm" :disabled="isLoading" variant="primary" @click="onOkClicked" class="mx-2">
        {{ $t('message.common_button_ok') }}
      </b-button>
    </div>
  </template>
</b-modal>